import { toast } from 'sonner'
import { useState, useEffect } from 'react'
import { fError } from '@/utils/format-error'
import { useBoolean } from '@/hooks/use-boolean'
import { useParams } from '@/routes/hooks/use-params'
import axiosInstance, { endpoints } from '@/lib/axios'
import LoadingSection from '@/components/loading-indicator/loading-section'

import type { TrendSound } from '../types'

import TrendSoundForm from '../trend-sound-form'

// ----------------------------------------------------------------------

export default function TrendSoundFormView() {
  const params = useParams()
  const loading = useBoolean(true)
  const [trendSound, setTrendSound] = useState<TrendSound | undefined>(undefined)
  const isEditMode = params.id !== undefined

  const fetchTrendSound = async () => {
    if (!isEditMode || !params.id) {
      loading.onFalse()
      return
    }

    try {
      loading.onTrue()
      const { data } = await axiosInstance.get<TrendSound>(
        endpoints.trendSounds.detail(params.id),
      )
      setTrendSound(data)
    } catch (error) {
      toast.error(fError(error))
    } finally {
      loading.onFalse()
    }
  }

  useEffect(() => {
    fetchTrendSound()
  }, [params.id])

  return (
    <LoadingSection loading={loading.value}>
      <TrendSoundForm
        trendSound={trendSound}
        mode={isEditMode ? 'edit' : 'create'}
      />
    </LoadingSection>
  )
}
